export const TOGGLE_CARD_DEVICE_SELECT = '@@cardDevice/TOGGLE_CARD_DEVICE_SELECT';
export const SAVE_CARD_DEVICE = '@@cardDevice/SAVE_CARD_DEVICE';

export const openCardDeviceSelect = () => ({
    type: TOGGLE_CARD_DEVICE_SELECT,
    open: true,
});

export const closeCardDeviceSelect = () => ({
    type: TOGGLE_CARD_DEVICE_SELECT,
    open: false,
});

export const saveCardDevice = cardDevice => ({
    type: SAVE_CARD_DEVICE,
    cardDevice,
});
